module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/brooklinen-d04586d15055c87a7e16ad974e56dc5d.png";